export const ADMINISTRATION_ACCOUNTS_ENTITY_NAME = 'administration.accounts.fns';
export const ADMINISTRATION_ACCOUNTS_ACTION_CODE = 'CHANGE_USER_STATUS';
export const BLOCK_REASONS_LIST_URL = `/getListReason/${ADMINISTRATION_ACCOUNTS_ENTITY_NAME}/${ADMINISTRATION_ACCOUNTS_ACTION_CODE}`;
export const FORM_TEXTS = {
    TITLE: 'Выберите причину блокировки пользователя:',
    CONFIRM: 'Вы уверены, что хотите заблокировать пользователя?',
    REASON_REQUIRED: 'Пожалуйста, выберите причину блокировки',
    REASON_PLACEHOLDER: 'Выберите причину блокировки',
    COMMENT_PLACEHOLDER: 'Введите комментарий',
};
export const BLOCK_BUTTON_TEXTS = {
    CONFIRM: 'Вы уверены, что хотите изменить статус активности пользователя?',
};
